export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/cash-out/create`,
        name: `${prefix}.cash-out.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.cash-out.create`,
                PageDescription: "Accounts - Cash Out",
            },
        },
    },
];
